import React from "react"
import layout_styles from "../components/layout.module.css"
import logo from "./Pandemonium-small.jpg"
export default ({ children }) => (
    
  <div>
  
    <div className={layout_styles.navbar}>
        <img className={layout_styles.navbarbrand} src={logo} alt="Logo"></img> 
        <h1 className={layout_styles.navbartitle}>Pandemonium</h1>
    </div>
    {children}
  </div>
)